export const RPC_PRODUCT_ENDPOINTS = {
    CATEGORIES: "/get_influencer_categories",
    GET_PRODUCT_LIST_PAGED: "/get_product_list_paged",
};
